var owlCarousel = require('owl.carousel');

var container = $('.owl-carousel');
container.owlCarousel({
	autoPlay: false,
	nav: false,
	pagination: false,
	dots: false,
	margin: 15,
	responsiveClass: true,
	items: 3,
  stagePadding: 20,
	loop: false,
	responsive: {
		480: { items: 2},
		768: { items: 3},
		1024: { items: 3}
	}
});



// WEBPACK FOOTER //
// ./js/modules/_owlcarousel.js